export const mqttConfig = {
    'data': {
        url: "wss://local.vrmaker.com.cn:18888/mqtt",
        // url: "ws://192.168.33.141:8083/mqtt",
        username: "vrmaker",
        password: "vrmaker",
    },
    'control': {
        url: "mqtt://local.vrmaker.vip:8083/mq/ws",
        username: "mqtt_ctrl",
        password: "vrmaker",
    }
}